import { render, staticRenderFns } from "./PermissionsModal.vue?vue&type=template&id=28567d52&scoped=true&"
import script from "./PermissionsModal.vue?vue&type=script&lang=js&"
export * from "./PermissionsModal.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsModal.vue?vue&type=style&index=0&id=28567d52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28567d52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28567d52')) {
      api.createRecord('28567d52', component.options)
    } else {
      api.reload('28567d52', component.options)
    }
    module.hot.accept("./PermissionsModal.vue?vue&type=template&id=28567d52&scoped=true&", function () {
      api.rerender('28567d52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/PermissionsModal.vue"
export default component.exports